export default __webpack_public_path__ + "static/media/$odaCoin.5d5605dc.svg";